export default __webpack_public_path__ + "static/suzuki1_main-3746d8788882b9a5a61918c2e54ab412.jpg";